import { ScrollArea, Stack, Text, useMantineTheme } from '@mantine/core'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { TokenBase } from '@/schemas/types'
import { shortenHash } from '@/utils/utils'

import RootButton from '../Buttons/RootButton'
import TooltipText from '../TooltipText'

interface MetadataNotFoundProps {
  parentRef?: React.RefObject<HTMLDivElement>
  elem: TokenBase
  width?: number
  height?: number
  error: string
  url: string
}

const MetadataNotFound: React.FC<MetadataNotFoundProps> = ({
  parentRef,
  elem,
  error,
  url,
  width = 290,
  height = 290,
}) => {
  const theme = useMantineTheme()
  const { t } = useTranslation()
  const [parentWidth, setParentWidth] = useState(width)
  const [parentHeight, setParentHeight] = useState(height)

  useEffect(() => {
    const handleWindowResize = () => {
      setParentWidth(parentRef?.current?.clientWidth || width)
      setParentHeight(parentRef?.current?.clientWidth || height)
    }
    handleWindowResize()

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  return (
    <Stack gap="14px">
      <ScrollArea
        style={{
          borderRadius: '12px',
          backgroundColor: theme.colors.background2[0],
          flexDirection: 'column',
          justifyContent: 'space-evenly',
          height: parentHeight,
          width: parentWidth,
          zIndex: 1,
        }}
      >
        <Stack style={{ justifyContent: 'center', alignItems: 'center', height: parentHeight }}>
          <TooltipText
            text={error}
            textStyle={{
              textAlign: 'center',
              maxWidth: '80%',
            }}
            tooltip={t(
              'components.items.metadataFetchFailed',
              'LAMINA1 Hub tried to fetch metadata from URI, but received an invalid response, or none at all.'
            )}
          />
          {elem?.metadata !== 'null' ? (
            <Text
              style={{
                textAlign: 'center',
                maxWidth: '80%',
              }}
            >
              {elem?.uri !== '... Searching ...' && url ? (
                <>
                  URI:{' '}
                  <Link to={url} target="_blank">
                    link
                  </Link>
                </>
              ) : (
                t('components.items.uriNotValidLink', 'URI not a valid link')
              )}
            </Text>
          ) : url ? (
            <RootButton
              secondary
              onClick={() => {
                window.open(url, '_blank')
              }}
            >
              {t('components.items.viewMetadata', 'View Metadata')}
            </RootButton>
          ) : (
            <Text
              style={{
                textAlign: 'center',
                maxWidth: '80%',
                maxHeight: '120px',
                overflow: 'scroll',
              }}
            >
              Metadata:
              <br />
              {elem?.metadata}
            </Text>
          )}
        </Stack>
      </ScrollArea>
      <Stack gap="8px" style={{ zIndex: 0 }}>
        <Stack style={{ flexDirection: 'row', gap: '5px' }}>
          <Stack
            style={{
              backgroundColor: theme.colors.background2[0],
              width: '100%',
              height: '26px',
              borderRadius: '8px',
              padding: '2px 8px',
              justifyContent: 'center',
              flexDirection: 'row',
              gap: '8px',
            }}
          >
            {!url && elem?.metadata !== 'null' && (
              <>
                <Text>ID</Text>
                <TooltipText text={shortenHash(elem?.id)} tooltip={elem?.id} />
              </>
            )}
          </Stack>
        </Stack>
        {/* <Stack
          style={{
            backgroundColor: theme.colors.background2[0],
            width: parentWidth,
            height: '22px',
            borderRadius: '6px',
            padding: '0 5px',
            justifyContent: 'center',
          }}
        >
          {!url && elem?.metadata !== 'null' && (
            <Text className={utils.truncate}>{`Name: ${elem?.metadata?.name || 'Unknown'}`}</Text>
          )}
        </Stack> */}
      </Stack>
    </Stack>
  )
}

export default MetadataNotFound
